import { create } from "zustand";

interface IUseKnowYourCustomerStoreProps {
  verificationStatus?: string;
  setVerificationStatus: (verificationStatus?: string) => void;
}

export const useKnowYourCustomerStore = create<IUseKnowYourCustomerStoreProps>(
  (set) => ({
    setVerificationStatus: (verificationStatus) => set({ verificationStatus }),
  }),
);
